<template>
<div class="ibox">
    <div class="ibox-title">
        <h5>Graficos</h5>
        <div class="ibox-tools">
            <a class="collapse-link">
                <i class="fa fa-chevron-up"></i>
            </a>
        </div>
    </div>
    <div class="ibox-content table-responsive">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox-title">
                    <h5>Interacciones por hora</h5>
                </div>
                <div class="ibox-content" v-if="conversaciones.length > 0">
                    <div id="morris-bar-chart"></div>
                </div>
                <div v-else style="width: 100%; padding: 50px 0px; text-align: center">
                    <h4>No se encontraron resultados</h4>
                </div>
            </div>
        </div>
        <!-- Grafico de Lineas -->
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox float-e-margins">
                    <div class="ibox-title">
                        <h5>Cantidad de interacciones por hora</h5>
                    </div>
                    <div class="ibox-content" v-if="por_hora.length > 0">
                        <div id="morris-one-line-chart"></div>
                    </div>
                    <div v-else style="width: 100%; padding: 50px 0px; text-align: center">
                        <h4>No se encontraron resultados</h4>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="col-lg-4">
            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <h5 style="font-size: 11px">Porcentaje Interacciones Activas</h5>
                </div>
                <div class="ibox-content">
                    <div>
                        <div id="activas" style="width: 300px"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <h5 style="font-size: 11px">Porcentaje Interacciones Pendientes</h5>
                </div>
                <div class="ibox-content">
                    <div>
                        <div id="pendientes" style="width: 300px"></div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-lg-4">
                <div class="ibox float-e-margins">
                    <div class="ibox-title">
                        <h5 style="font-size: 11px">Porcentaje Interacciones Resueltas</h5>
                    </div>
                    <div class="ibox-content" id="percent">
                        <div>
                            <div id="resueltas" style="width: 300px"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="ibox float-e-margins">
                    <div class="ibox-title">
                        <h5 style="font-size: 11px">
                            Porcentaje Interacciones Sin resolver
                        </h5>
                    </div>
                    <div class="ibox-content">
                        <div>
                            <div id="sresolver" style="width: 300px"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="ibox float-e-margins">
                    <div class="ibox-title">
                        <h5 style="font-size: 11px">Porcentaje Interacciones Pendientes/Contestadas</h5>
                    </div>
                    <div class="ibox-content">
                        <div>
                            <div id="pendientes" style="width: 300px"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <h4 style="margin-left: auto; width: 173px; margin-right: auto;">Interacciones sin resolver</h4>
            </div>
            <div class="col-lg-2"></div>
            <div class="col-lg-4">
                <div class="ibox float-e-margins">
                    <div class="ibox-title">
                        <h5 style="font-size: 11px">Porcentaje Interacciones Expiradas</h5>
                    </div>
                    <div class="ibox-content">
                        <div>
                            <div id="expiradas" style="width: 300px"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="ibox float-e-margins">
                    <div class="ibox-title">
                        <h5 style="font-size: 11px">Porcentaje Cerrado Insatisfactorio</h5>
                    </div>
                    <div class="ibox-content">
                        <div>
                            <div id="insatisfactorias" style="width: 300px"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2"></div>
        </div>

        <div class="row">
            <h4 style="padding-left:15px">Interacciones Finalizadas</h4>
            <!-- <div class="col-lg-4">
                <div class="ibox float-e-margins">
                    <div class="ibox-title">
                        <h5 style="font-size: 11px">
                            Porcentaje Interacciones Finalizada por BOT
                        </h5>
                    </div>
                    <div class="ibox-content">
                        <div>
                            <div id="fbot" style="width: 300px"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="ibox float-e-margins">
                    <div class="ibox-title">
                        <h5 style="font-size: 11px">
                            Porcentaje Interacciones Finalizada por agente
                        </h5>
                    </div>
                    <div class="ibox-content">
                        <div>
                            <div id="fagente" style="width: 300px"></div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="col-lg-6">
                <div class="ibox float-e-margins">
                    <div class="ibox-title">
                        <h5>Interacciones finalizadas</h5>
                    </div>
                    <div class="ibox-content">
                        <div>
                            <div id="pie"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
var moment = require('moment');
import { mapGetters } from 'vuex'
export default {
    computed: {
        por_hora() {
            let interacciones = this.$store.getters["graficos/getInteraccionPorHora"];
            // console.log(interacciones);
            return interacciones;
        },
        promedios() {
            let promedios = this.$store.getters["graficos/getPromedios"];
            // console.log(promedios);
            return promedios;
        },
        porcententaje_interacciones() {
            let interacciones = this.$store.getters[
                "graficos/getPorcentajeIntreracciones"
            ];
            // console.log(interacciones);
            return interacciones;
        },
        conversaciones() {
            let conversaciones = this.$store.getters["graficos/getConversaciones"];
            // console.log(interacciones);
            return conversaciones;
        },
        fecha_inicio() {
            return this.$store.getters['graficos/getFechaInicio']

        },
        fecha_final() {
            return this.$store.getters['graficos/getFechaFinal']
        }
    },
    mounted() {
        let date = new Date();
        date = moment(date).format('D-M-YYYY');
        Echo.join('graficos-canal')
            .listen('GraficosEvent', (e) => {
                if (date == this.fecha_inicio && date == this.fecha_final)
                    this.$store.commit('graficos/setDataGraficos', e);
                else
                    console.log("no es el dia de hoy");

            }).on('pusher:subscription_error', (error) => {
                console.log("error", JSON.stringify(error));
            })
    },
    methods: {
        init() {
            const por_hora = this.por_hora;
            const promedios = this.promedios;
            const conversaciones = this.conversaciones;
            $(function () {
                $("#morris-bar-chart > svg").remove();
                $("#morris-one-line-chart > svg").remove();
                $("#morris-one-line-chart > svg").remove();

                $("#morris-one-line-chart > .morris-default-style").remove();
                $("#morris-bar-chart > .morris-default-style").remove();

                if (conversaciones.length > 0) {
                    Morris.Bar({
                        element: "morris-bar-chart",
                        data: conversaciones,
                        xkey: "y",
                        ykeys: ["a", "b"],
                        labels: ["Conversaciones", "Contactos"],
                        hideHover: "auto",
                        resize: true,
                        barColors: ["#1ab394", "#cacaca", "#71bc78"],
                    });
                }

                if (por_hora.length > 0) {
                    Morris.Line({
                        element: "morris-one-line-chart",
                        data: por_hora,
                        xkey: "hora",
                        ykeys: ["value"],
                        resize: true,
                        yLabelFormat: function (y) {
                            return y != Math.round(y) ? "" : y;
                        },
                        lineWidth: 4,
                        labels: ["Interacciones"],
                        lineColors: ["#1ab394"],
                        parseTime: false,
                        pointSize: 5,
                    });
                }

                // console.log(promedios);
                // $("#activas > svg").remove();
                // $("#pendientes > svg").remove();
                $("#resueltas > svg").remove();
                $("#derivadas > svg").remove();
                $("#sresolver > svg").remove();
                $("#fbot > svg").remove();
                $("#fagente > svg").remove();
                $("#pie > svg").remove();
                // c3.generate({
                //     bindto: "#activas",
                //     data: {
                //         columns: [
                //             ["Activos", promedios.promedio_contestada]
                //         ],

                //         type: "gauge",
                //     },
                //     color: {
                //         pattern: ["#1ab394", "#e0e0e0"],
                //     },
                // });

                let width = $("#percent").width();
                // console.log(width);

                c3.generate({
                    bindto: "#pendientes",
                    data: {
                        columns: [
                            ["Pendientes", promedios.promedio_pendiente]
                        ],

                        type: "gauge",
                    },
                    color: {
                        pattern: ["#1ab394", "#e0e0e0"],
                    },
                    size: {
                        width: width
                    }
                });
                // console.log(promedios);
                c3.generate({
                    bindto: "#resueltas",
                    data: {
                        columns: [
                            ["Resueltas", promedios.promedio_resuelta]
                        ],

                        type: "gauge",
                    },
                    color: {
                        pattern: ["#1ab394", "#e0e0e0"],
                    },
                    size: {
                        width: width
                    }
                });

                c3.generate({
                    bindto: "#sresolver",
                    data: {
                        columns: [
                            ["Sin Resolver", promedios.promedio_sin_resolver]
                        ],

                        type: "gauge",
                    },
                    color: {
                        pattern: ["#1ab394", "#e0e0e0"],
                    },
                    size: {
                        width: width
                    }
                });

                c3.generate({
                    bindto: "#expiradas",
                    data: {
                        columns: [
                            ["Expiradas", promedios.promedio_expiradas]
                        ],

                        type: "gauge",
                    },
                    color: {
                        pattern: ["#1ab394", "#e0e0e0"],
                    },
                    size: {
                        width: width
                    }
                });

                c3.generate({
                    bindto: "#insatisfactorias",
                    data: {
                        columns: [
                            ["Cerrado Insatisfactorio", promedios.promedio_error]
                        ],

                        type: "gauge",
                    },
                    color: {
                        pattern: ["#1ab394", "#e0e0e0"],
                    },
                    size: {
                        width: width
                    }
                });

                c3.generate({
                    bindto: "#fbot",
                    data: {
                        columns: [
                            ["Finalizada por bot", promedios.promedio_finalizada_por_bot],
                        ],

                        type: "gauge",
                    },
                    color: {
                        pattern: ["#1ab394", "#e0e0e0"],
                    },
                    size: {
                        width: width
                    }
                });

                c3.generate({
                    bindto: "#fagente",
                    data: {
                        columns: [
                            [
                                "Finalizada por agente",
                                promedios.promedio_finalizada_por_agente,
                            ],
                        ],

                        type: "gauge",
                    },
                    color: {
                        pattern: ["#1ab394", "#e0e0e0"],
                    },
                    size: {
                        width: width
                    }
                });

                c3.generate({
                    bindto: "#pie",
                    data: {
                        columns: [
                            ["Por Bot", promedios.promedio_finalizada_por_bot],
                            ["Por Agente", promedios.promedio_finalizada_por_agente],
                        ],
                        colors: {
                            "Por Bot": '#1ab394',
                            "Por Agente": '#3e872d',
                        },
                        type: "pie",
                    },
                });
            });
        },
    },
    watch: {
        por_hora() {
            // console.log(this.por_hora);
            this.init();
        },
    },
};
</script>
